import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControlLabel,
  Grid2,
  Snackbar,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import Navbar from './Navbar';
import HeadingText from '../../BuiltInComponent/HeadingTest';
import {
  DEFAULT_POS_ORDER_TYPE_SETTINGS,
  fetchPosOrderTypeSettings,
  savePosOrderTypeSettings,
} from '../../utils/posOrderTypeSettings';

const OPTIONS = [
  { key: 'enableDineIn', title: 'Dine In', description: 'Table orders aur dine-in billing enable rakhein.' },
  { key: 'enableTakeaway', title: 'Takeaway', description: 'Counter takeaway orders enable rakhein.' },
  { key: 'enableDelivery', title: 'Delivery', description: 'Regular customer delivery orders enable rakhein.' },
  { key: 'enableFoodpanda', title: 'Foodpanda', description: 'Foodpanda aggregator orders enable rakhein.' },
];

export default function POSOrderTypeSettings() {
  const [settings, setSettings] = useState(DEFAULT_POS_ORDER_TYPE_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const data = await fetchPosOrderTypeSettings();
        setSettings(data);
      } catch (error) {
        setMessage('Settings load nahi ho sakin. Defaults use ho rahe hain.');
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  const enabledCount = useMemo(
    () => Object.values(settings).filter(Boolean).length,
    [settings]
  );

  const handleToggle = (key) => (_event, checked) => {
    setSettings((prev) => ({ ...prev, [key]: checked }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const data = await savePosOrderTypeSettings(settings);
      setSettings(data);
      setMessage('POS order type settings save ho gayi hain.');
    } catch (error) {
      setMessage(error?.response?.data?.message || 'Settings save nahi ho sakin.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="md" sx={{ py: 3 }}>
        <HeadingText text="POS Order Type Settings" />

        <Card variant="outlined" sx={{ mt: 2 }}>
          <CardContent>
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary">
                POS screen par jo order modes istemal karne hain unhein enable rakhein. Agar sab off kar dein to system Takeaway ko fallback ke tor par on rakhega.
              </Typography>

              <Grid2 container spacing={2}>
                {OPTIONS.map((option) => (
                  <Grid2 size={{ xs: 12, sm: 6 }} key={option.key}>
                    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 2 }}>
                      <FormControlLabel
                        control={(
                          <Switch
                            checked={Boolean(settings[option.key])}
                            onChange={handleToggle(option.key)}
                            disabled={loading || saving}
                          />
                        )}
                        label={<Typography fontWeight={700}>{option.title}</Typography>}
                      />
                      <Typography variant="body2" color="text.secondary">
                        {option.description}
                      </Typography>
                    </Box>
                  </Grid2>
                ))}
              </Grid2>

              {enabledCount === 0 && (
                <Alert severity="warning">
                  Kam az kam ek option enabled hona chahiye. Save par Takeaway automatic enable ho jayega.
                </Alert>
              )}

              <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  onClick={() => setSettings(DEFAULT_POS_ORDER_TYPE_SETTINGS)}
                  disabled={loading || saving}
                >
                  Enable All
                </Button>
                <Button variant="contained" onClick={handleSave} disabled={loading || saving}>
                  {saving ? 'Saving...' : 'Save Settings'}
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>

      <Snackbar open={Boolean(message)} autoHideDuration={3500} onClose={() => setMessage('')}>
        <Alert onClose={() => setMessage('')} severity="info" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
